import styled from 'styled-components';

interface IContainer {
  disabled?: boolean;
  marginContainer?: string;
}
interface IHolder {
  margin?: number;
}

export const Container = styled.div<IContainer>`
  color: #fff;
  grid-column: span 2;
  @media (max-width: 1610px) {
    grid-column: span 2;
  }
  @media (max-width: 1030px) {
    grid-column: span 2;
  }
  @media (max-width: 770px) {
    grid-column: unset;
  }
  @media (max-width: 430px) {
    grid-column: unset;
  }
  display: flex;
  ${(props) => (props.marginContainer ? `margin: ${props.marginContainer};` : '')}
  & .button {
    margin-top: 30px;
    height: 40px;
    width: 50%;
    border-radius: 30px;
    text-transform: capitalize;
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: #74c598;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    border: 0.8px solid #74c598;
  }
  @media (max-width: 1610px) {
    & .button {
      height: 35px !important;
      margin-top: 25px;
    }
  }
  align-self: end;
`;
export const Holder = styled.div<IHolder>`
  width: 50%;
  margin-right: ${(props) => props.margin || 15}px;
  align-self: end;
`;

export const Label = styled.label`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  color: #6e6e6e;
  font-weight: normal;
  display: inline-block;
  margin-bottom: 5px;

  @media (max-width: 1610px) {
    font-size: 10px;
  }
`;
interface IFileComponent {
  drag?: boolean;
}
export const FileComponent = styled.div<IFileComponent>`
  margin-bottom: unset !important;
  background-color: #f5f5f5;
  color: #a8a8a8;
  border-radius: 10px;
  margin-top: unset !important;
  display: flex !important;
  height: 40px;
  font-size: 12px;
  ${(props) => props.drag && 'border: 2px dashed #ccc;'}

  & input:first-child {
    display: none;
  }

  & input {
    margin-top: 0 !important;
    padding-left: 10px;
    padding-right: 10px;
    font-family: 'Roboto', sans-serif !important;
    font-size: 12px;
    margin-bottom: unset !important;
    color: #6e6e6e !important;
    background-color: transparent !important;
    width: 100% !important;
    border-radius: 10px;
    border: 0.8px solid #eae7e7;
    cursor: default !important;
  }

  & input::placeholder {
    color: #a8a8a8;
  }

  @media (max-width: 1610px) {
    height: 35px !important;
    font-size: 10px !important;

    & input {
      height: 35px !important;
      font-size: 10px !important;
    }
  }
`;
